import { BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxBootstrapLocaleMappingService } from './ngx-bootstrap-locale-mapping.service';
import {
  defineLocale,
  enGbLocale,
} from 'ngx-bootstrap/chronos';


export class NgxBootstrapDatePickerConfigService {

  static getDaterangepickerConfig(): BsDaterangepickerConfig {
    return Object.assign(new BsDaterangepickerConfig(), {
      containerClass: 'theme-' + NgxBootstrapDatePickerConfigService.getTheme()
    });
  }

  static getDatepickerConfig(): BsDatepickerConfig {
    return Object.assign(new BsDatepickerConfig(), {
      containerClass: 'theme-' + NgxBootstrapDatePickerConfigService.getTheme()
    });
  }

  static getTheme(): string {
    return 'green';
  }

  static getDatepickerLocale(): BsLocaleService {
    let localeService = new BsLocaleService();
    var locale = abp.localization.currentLanguage.name == 'en'
      ? 'en-gb'
      : abp.localization.currentLanguage.name;
    localeService.use(locale);
    return localeService;
  }

  static registerNgxBootstrapDatePickerLocales(): Promise<boolean> {

    let supportedLocale: string;
    if (abp.localization.currentLanguage.name === 'en') {
      supportedLocale = 'en-gb';
    } else {
      supportedLocale = new NgxBootstrapLocaleMappingService().map(abp.localization.currentLanguage.name).toLowerCase();
    }
    const localeData = new NgxBootstrapLocaleMappingService().getLocale(supportedLocale);
    defineLocale(supportedLocale.toLowerCase(), localeData);
    return Promise.resolve(true);
  }
}
